// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Greece */
const GR = /^(?:68[57-9]\d{7}|(?:69|94)\d{8})$/;

export default GR;
